/* Addon photo zoom (owner 2026-08-26): the personalizer's addon cards show a
   75px thumbnail (matching keychain etc.) that is too small to judge the
   product by. This dresses each thumbnail with a zoom button + badge (badge
   drawn by sis-skin.css on .sis-thumb-zoom) and opens a shared <dialog> with
   a larger transform of the same image.

   THIRD-REPO DOM: .sisp__* markup belongs to the sis-studio extension - see
   the "personalizer (app)" entry in sis-skin.css's manifest. Two contracts
   this leans on, verified 2026-08-26:
   - the thumb <span class="sisp__thumb"> sits OUTSIDE the toggle's <label>,
     and the extension's card-wide click-to-toggle handler ignores any click
     inside a `button` (sis-personalizer.js ~ln 751), so opening the lightbox
     can never flip the addon;
   - thumbnail src carries a ?width=150 (or &width=150) transform param; the
     lightbox re-requests the SAME file at width=1200 (2x the dialog cap).

   The thumb span ships aria-hidden (decorative img). Once it holds a real
   control that attribute must go - a focusable element inside aria-hidden is
   an a11y bug - so dressing removes it and the button carries the label. */
(function () {
  'use strict';

  if (!('HTMLDialogElement' in window)) return;

  var script = document.getElementById('sis-addon-zoom');
  var LABEL_ZOOM = (script && script.dataset.labelZoom) || 'Zoom';
  var LABEL_CLOSE = (script && script.dataset.labelClose) || 'Close';

  var dialog = null;
  function getDialog() {
    if (dialog && dialog.isConnected) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'sis-zoom-dialog';
    var img = document.createElement('img');
    img.alt = '';
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'sis-zoom-dialog__close';
    close.setAttribute('aria-label', LABEL_CLOSE);
    close.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    close.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });
    /* showModal() does NOT lock background scroll (Horizon's own dialog.js
       carries a lockScroll for exactly this reason): without the class a
       swipe on the open lightbox pans the page underneath and the user loses
       the addon card they were on. Class-toggle instead of :has() so Firefox
       98-120 (dialog without :has) is covered too. */
    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('sis-zoom-open');
      /* the shared img keeps its last bitmap otherwise, so the NEXT addon's
         zoom would open showing the PREVIOUS addon's photo while its own
         1200px fetch runs */
      img.onerror = null;
      img.removeAttribute('src');
      img.alt = '';
    });
    dialog.appendChild(img);
    dialog.appendChild(close);
    document.body.appendChild(dialog);
    return dialog;
  }

  function fullSrc(src) {
    /* A snapshot URL may carry a baked _NxN size suffix, which HARD-CAPS the
       render - width= on top of it is ignored (measured in the extension,
       see its thumb comment). Strip it so 1200 actually applies. A filename
       that legitimately ends in digitsxdigits (sign_12x16.png) would break
       here, which is what the onerror fallback below is for. */
    return src
      .replace(/_\d+x\d+(?=\.[a-z]{2,5}(\?|$))/i, '')
      .replace(/([?&])width=\d+/, '$1width=1200');
  }

  function open(img, name) {
    var d = getDialog();
    var di = d.querySelector('img');
    var thumb = img.currentSrc || img.src;
    di.onerror = function () {
      di.onerror = null;
      di.src = thumb;
    };
    di.src = fullSrc(thumb);
    di.alt = name;
    d.setAttribute('aria-label', name ? LABEL_ZOOM + ': ' + name : LABEL_ZOOM);
    document.documentElement.classList.add('sis-zoom-open');
    d.showModal();
  }

  function dress(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var thumbs = scope.querySelectorAll('.sisp__field--thumbed .sisp__thumb:not([data-sis-zoom])');
    for (var i = 0; i < thumbs.length; i++) {
      (function (span) {
        span.setAttribute('data-sis-zoom', '');
        var img = span.querySelector('img');
        if (!img) return;
        var field = span.closest('.sisp__field');
        var labelEl = field && field.querySelector('.sisp__label');
        var name = labelEl ? labelEl.textContent.trim() : '';
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'sis-thumb-zoom';
        btn.setAttribute('aria-label', name ? LABEL_ZOOM + ': ' + name : LABEL_ZOOM);
        span.removeAttribute('aria-hidden');
        btn.appendChild(img);
        span.appendChild(btn);
        btn.addEventListener('click', function () { open(img, name); });
      })(thumbs[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { dress(document); });
  } else {
    dress(document);
  }
  /* Theme editor re-renders sections wholesale; re-dress whatever came back. */
  document.addEventListener('shopify:section:load', function (e) { dress(e.target); });
})();
